import { useDrag } from 'react-dnd';

import { TeamPlayerInfo } from '@/lib/types';
import { ItemType } from '@/lib/types';
import PlayerCard from '@/app/team-leagues/[teamLeagueId]/(secure)/teams/[teamId]/player-moves/add-player/_components/player-card';
interface DraggablePlayerProps {
	player: TeamPlayerInfo;
}

export default function DraggablePlayer({ player }: DraggablePlayerProps) {
	const [, drag] = useDrag({
		type: ItemType.PLAYER,
		item: player
	});

	return drag(
		<div className={`h-fit translate-x-0 translate-y-0 cursor-move`}>
			<PlayerCard
				name={player.firstName + ' ' + player.lastName}
				phone={player.phone}
				internationalCountryCallingCode={player.country?.internationalCountryCallingCode || ''}
				duprDoubles={player.ratingDoubles}
				duprSingles={player.ratingSingles}
				image={player.photo}
			/>
		</div>
	);
}
